// extracted by css-extract-rspack-plugin
export default {"container":"_6412e8be","header":"_b7cdf0a6","designs":"_bfffcc18","justifyCenter":"_3d97eedc","viewMoreButtonDiv":"_e2f199ac","viewMoreButton":"_adab8877"};